import React, { Component } from "react";
import Countdown from "./Countdown.jsx";
import YoutubeEmbed from "./YoutubeEmbed.jsx";

class App extends Component {
  render() {
    const currentDate = new Date();
    const year =
      currentDate.getMonth() === 11 && currentDate.getDate() > 23
        ? currentDate.getFullYear() + 1
        : currentDate.getFullYear();
    return (
      <div className='App'>
        {/* <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>React Countdown</h2>

          <a
            href="https://github.com/kristinbaumann/react-countdown"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={github} alt="github" className="githubIcon" />
            <span>View on Github</span>
          </a>
        </div> */}
        <h3 className='title'>
          {/* Christmas Eve is coming soon (Midnight of 23rd to 24th Dec, UTC time): */}
          Onboarding starts on June 3rd, 2024 at 9:30 AM
        </h3>
        <Countdown date={`${year}-06-03T09:30:00`} />{" "}
        {/* <YoutubeEmbed embedId="lAkuJXGldrM" /> */}
      </div>
    );
  }
}

export default App;
